(function GroupRegistrationPaymentInformation($, Adzuki)
{
	"use strict";

	Adzuki.onload('GroupRegistrations/paymentInformation/', init, false);

	function init()
	{
		$('.authorization_amount').on('keyup', updateAuthorizationAmount);
		$('.name_on_card').on('keyup', updateNameOnCard);
		$('.country').on('change', handleCountryChange);

		$('.authorization_amount').keyup();
		$('.country').change();
	}

	function updateAuthorizationAmount()
	{
		var value      = $(this).val();
		var $container = $(this).closest('.credit-card-authorization');

		$container.find('.authorization-amount').html(value);
	}

	function updateNameOnCard()
	{
		var value      = $(this).val();
		var $container = $(this).closest('.credit-card-authorization');

		$container.find('.name-on-card').html(value);
	}

	function handleCountryChange()
	{
		var country_id = $(this).val();
		// var prefix = $(this).data('prefix');
		var $container = $(this).closest('.credit-card-authorization');

		// Hide state
		$container.find('.state-container').addClass('hidden');
		$container.find('.province-container').addClass('hidden');

		if (country_id === '183') {
			$container.find('.state-container').removeClass('hidden');
		} else if (country_id === '31') {
			$container.find('.province-container').removeClass('hidden');
		}
	}

}(jQuery, window.Adzuki || {}));